import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, Typography, Link,
} from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import EmailIcon from '@mui/icons-material/Email';
import useHomePageStyle from '../styles/HomePageStyles.jsx';
import Avatar from '../assets/avatar.jpg';

const HomePage = ({ isMobile }) => {
  const {
    root,
    profileContainer,
    profileContainerMobile,
    avatar,
    name,
    description,
    links,
    link,
  } = useHomePageStyle();

  const profileContainerClass = isMobile ? `${profileContainer} ${profileContainerMobile}` : profileContainer;

  return (
    <Box className={root}>
      <Box className={profileContainerClass}>
        <img className={avatar} src={Avatar} alt='' />
        <Typography className={name}>Tingjun Man</Typography>
        <Typography className={description}>
          Software Engineer / Traveler / Photography Dabbler
          / Amateur Bartender / Day Dreamer / ...
        </Typography>

        <Box className={links}>
          <Link className={link} href='https://www.linkedin.com/in/tingjun-man/' target='_blank' color='inherit' >
            <LinkedInIcon fontSize='large' />
          </Link>

          <Link className={link} href='https://github.com/tm2838' target='_blank' color='inherit'>
            <GitHubIcon fontSize='large' />
          </Link>

          <Link className={link} href='mailto:tingjun.man@gmail.com?subject=Hi Tingjun' color='inherit'>
            <EmailIcon fontSize='large' />
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

HomePage.propTypes = {
  isMobile: PropTypes.bool,
};

export default HomePage;
